import { SET_VERIFICATION_SUCCESS, SET_VERIFICATION_FAIL } from './types';

export const setVerification = (
	leadId,
	selectedClient,
	// individualId,
	isAdd
) => {
	return async (dispatch) => {
		try {
			var payload = {
				leadId: leadId,
				selectedClient: selectedClient,
				// individualId: individualId,
				isAdd: isAdd,
			};
			dispatch(setVerificationSuccess(payload));
		} catch (error) {
			dispatch(setVerificationFail(error));
		}
	};
};

export const setVerificationSuccess = (payload) => ({
	type: SET_VERIFICATION_SUCCESS,
	payload,
});

export const setVerificationFail = (payload) => ({
	type: SET_VERIFICATION_FAIL,
	payload,
});
